import * as React from 'react';
import { IconHelpCircle } from 'icon/General/help-circle';
import { Tooltip, TooltipContent, TooltipTrigger } from 'ui';

type InfoTooltipProps = {
  title: string;
  description: React.ReactNode;
};
export function InfoTooltip({ title, description }: InfoTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger className="mt-0.5">
        <IconHelpCircle className="text-gray-400" height={18} width={18} />
        <span className="sr-only">More info</span>
      </TooltipTrigger>
      <TooltipContent className="max-w-64">
        <h3 className="font-semibold">{title}</h3>
        <p className="pt-1 text-gray-600">{description}</p>
      </TooltipContent>
    </Tooltip>
  );
}
